import { getExternalInvitationsDtoSchema } from '@/data/http/external-invitation/external-invitation.dto.schema';
import { HttpService } from '@/data/http/http-service';
import {
  ExternalInvitation,
  Scope,
  Status,
} from '@/domain/external-invitation/entities/external-invitation.entity';
import { ExternalInvitationGateway } from '@/domain/external-invitation/gateway/external-invitation.gateway';
import { Sector } from '@/domain/impact/impact.entity';
import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';

import { ExternalInvitationMapper } from './external-invitation.mapper';

export class ApiExternalInvitationHttpGateway implements ExternalInvitationGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });

  async invite(
    name: string,
    email: string,
    limitDate: string,
    eventPosition: PositionGeocode | undefined,
    title: string,
    sector: Sector,
    scope: Scope,
    projectId: number,
    organisationId: number,
  ) {
    const url = '/invitations';
    const data = ExternalInvitationMapper.buildInviteInputParams(
      name,
      email,
      limitDate,
      eventPosition,
      title,
      sector,
      scope,
      projectId,
      organisationId,
    );
    const response = await this.http.post(url, data);
    if (response.status === 201) {
      return;
    } else {
      throw 'error on invite';
    }
  }

  async getInvitations(projectId: number): Promise<ExternalInvitation[]> {
    const url = '/invitations';
    const options = { params: { projectId: projectId, $limit: 1000 } };
    const response = await this.http.get(url, options);
    const result = getExternalInvitationsDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const invitations: ExternalInvitation[] = result.data.data.map((x) =>
      ExternalInvitationMapper.dtoToEntity(x),
    );
    return invitations;
  }

  async changeInvitationIsValidated(
    invitationId: number,
    isValidated: boolean,
  ): Promise<void> {
    const url = `/invitations/${invitationId}`;
    const data = { isValidated: isValidated };
    const response = await this.http.patch(url, data);
    if (response.status === 200) {
      return;
    } else {
      throw 'error on change invitation';
    }
  }

  async changeInvitationStatus(
    invitationId: number,
    status: Status,
  ): Promise<void> {
    const url = `/invitations/${invitationId}`;
    const response = await this.http.patch(url, { status });
    if (response.status === 200) {
      return;
    } else {
      throw 'error on change invitation status';
    }
  }
}
